<template>
  <div>
    <v-form v-model="itemFormValid" lazy-validation ref="itemForm">
      <v-layout wrap align-center>
        <v-flex xs12 sm6 offset-sm3>
          <v-btn
            flat
            icon
            :to="{
              name: 'card-pages-list',
              params: { cardPage: $route.params.cardPage }
            }"
            exact
            :disabled="loading || (item && !item.image)"
          >
            <v-icon v-text="fa('angle-left')"></v-icon>
          </v-btn>
          <v-card v-if="item">
            <v-card-title>
              <v-layout row wrap>
                <v-flex xs12>
                  <icon-picker v-model="item.icon" />
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-img v-if="item.image" :src="item.image" aspect-ratio="2.75" />

            <v-card-title primary-title>
              <div class="flex">
                <Storage
                  v-model="item.image"
                  :type="
                    `cardPages/${$route.params.cardPage}/items/${
                      $route.params.id
                    }`
                  "
                />
                <v-alert :value="true" type="error" v-if="!item.image">
                  Image is mandatory
                </v-alert>
                <v-text-field
                  label="Title"
                  v-model="item.title"
                  :rules="[formRules.required]"
                />
                <v-text-field
                  label="Subtitle"
                  v-model="item.subTitle"
                  :rules="[formRules.required]"
                />

                <v-layout wrap row>
                  <v-flex xs4>
                    <ActionType v-model="item.tapAction.type" />
                  </v-flex>
                  <v-flex xs8>
                    <ActionLink
                      v-model="item.tapAction.link"
                      :type="item.tapAction.type"
                      @clearLink="$delete(item.tapAction, 'link')"
                    />
                  </v-flex>
                </v-layout>
                <!-- <v-flex xs12>
                  <v-subheader>Metadata</v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap v-for="(key, i) of metadataKeys" :key="i">
                    <v-flex xs12 sm2>
                      <v-text-field
                        label="Key"
                        v-model="metadataKeys[i]"
                        :rules="[formRules.required]"
                      />
                    </v-flex>
                    <v-flex xs12 sm9>
                      <v-text-field
                        label="Value"
                        v-model="metadataValues[i]"
                        :rules="[formRules.required]"
                      />
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn
                        @click="
                          metadataKeys.splice(i, 1);
                          metadataValues.splice(i, 1);
                        "
                        icon
                      >
                        <v-icon v-text="fa('trash-alt')"></v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-btn
                    block
                    @click="
                      metadataKeys.push('');
                      metadataValues.push('');
                    "
                  >
                    <v-icon v-text="fa('plus')"></v-icon> add
                  </v-btn>
                </v-flex> -->
              </div>
            </v-card-title>

            <div>
              <v-btn
                @click.stop="editAction(action)"
                v-for="(action, i) of item.actionItems"
                :key="i"
                v-text="action.text"
              />
              <v-btn @click.stop="editAction()" flat round icon>
                <v-icon v-text="fa('plus')"></v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-btn
            block
            color="primary"
            @click="save"
            :disabled="loading || (item && !item.image)"
            >Save</v-btn
          >
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="editDialogOpened" max-width="500">
      <v-card v-if="toEditAction">
        <v-form v-model="actionFormValid" lazy-validation ref="actionForm">
          <v-card-title>
            <span class="headline">Edit action</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <icon-picker v-model="toEditAction.action.icon" />
                </v-flex>
                <v-flex xs12 sm6>
                  <ActionType v-model="toEditAction.action.action.type" />
                </v-flex>
                <v-flex xs12 sm12 v-if="$route.params.language">
                  <ActionLink
                    v-model="toEditAction.action.action.link"
                    :type="toEditAction.action.action.type"
                    @clearLink="$delete(toEditAction.action.action, 'link')"
                  />
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="toEditAction.action.text"
                    label="Text"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="toEditAction.index > -1"
              flat
              @click="removeAction"
              :disabled="loading"
              color="warning"
              >Remove</v-btn
            >
            <v-spacer />
            <v-btn flat @click="closeActionDialog" :disabled="loading"
              >Close</v-btn
            >
            <v-btn flat @click="saveAction" :disabled="loading" color="primary"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";
import { db } from "../../plugins/firebase";
import { eventHub } from "../../config/constants";
import Storage from "../../components/Storage";

export default {
  name: "CardPageItem",
  components: {
    ActionLink,
    ActionType,
    Storage
  },
  data: () => ({
    itemFormValid: true,
    actionFormValid: true,
    editDialogOpened: false,
    loading: false,
    item: null,
    toEditAction: null
    // metadataKeys: [],
    // metadataValues: []
  }),
  async created() {
    const { cardPage, id } = this.$route.params;
    const cardPageDoc = db.collection("cardPages").doc(cardPage);
    this.$bind("item", cardPageDoc.collection("items").doc(String(id)));
  },
  // watch: {
  //   item(item) {
  //     this.metadataKeys = Object.keys(item.metadata);
  //     this.metadataValues = Object.values(item.metadata);
  //   }
  // },
  methods: {
    async save() {
      if (!this.$refs.itemForm.validate()) {
        return;
      }
      this.loading = true;
      const item = this.item;
      try {
        // this.item.metadata = this.metadataKeys.reduce((metadata, key, i) => {
        //   metadata[key] = this.metadataValues[i];
        //   return metadata;
        // }, {});
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.item, item)
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    editAction(action) {
      if (!action) {
        action = {
          action: {
            type: "NONE"
          },
          icon: null,
          text: null,
          showCondition: null
        };
      }
      this.toEditAction = {
        index: this.item.actionItems.indexOf(action),
        action: {
          ...action
        }
      };
      this.editDialogOpened = true;
    },
    async saveAction() {
      if (!this.$refs.actionForm.validate()) {
        return;
      }
      this.loading = true;
      const actionItems = this.item.actionItems;
      const previousActionItems = [...actionItems];
      try {
        if (actionItems[this.toEditAction.index]) {
          actionItems.splice(
            this.toEditAction.index,
            1,
            this.toEditAction.action
          );
        } else {
          actionItems.push(this.toEditAction.action);
        }
        await db.runTransaction(async t =>
          t.update(this.$firestoreRefs.item, "actionItems", actionItems)
        );
        eventHub.$emit("message", "green");
        this.toEditAction = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
        this.item.actionItems = previousActionItems;
      }
      this.loading = false;
      this.editDialogOpened = false;
    },
    async removeAction() {
      this.loading = true;
      const actionItems = this.item.actionItems;
      const previousActionItems = [...actionItems];
      try {
        actionItems.splice(this.toEditAction.index, 1);
        await db.runTransaction(async t =>
          t.update(this.$firestoreRefs.item, "actionItems", actionItems)
        );
        eventHub.$emit("message", "green");
        this.toEditAction = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
        this.item.actionItems = previousActionItems;
      }
      this.loading = false;
      this.editDialogOpened = false;
    },
    closeActionDialog() {
      this.toEditAction = null;
      this.editDialogOpened = false;
    }
  }
};
</script>
